import {Modal} from './modal';

/** Компонент открытия модала. */
export class OpenModal {
  /**
   * Конструктор класса.
   *
   * @param {HTMLElement} button Кнопка, открывающая модал.
   */
  constructor(button) {
    this.button = button;
    this.modalName = this.button.dataset.modal;
    this.modalTitle = this.button.dataset.modalTitle;
    this.bindEventListeners();
  }

  /**
   * Прослушиваем события для открытия модала.
   * Если модал открывается на кнопку в бургер-меню, то меню закрываем.
   *
   * @returns {void}
   */
  bindEventListeners() {
    this.button.addEventListener('click', () => {
      const modal = document.querySelector(`.js-modal[data-modal-name='${this.modalName}']`);
      Modal.open(modal);
    });
  }
}

document.querySelectorAll('.js-modal-open-button').forEach((button) => new OpenModal(button));
